import { useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import { resizeImageCard } from '../../utils/images';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ScoringPopup = ({ data }) => {
  const { photosType } = useSelector((state) => state.sensors);
  const popupRef = useRef(null);
  const [isBelow, setIsBelow] = useState(false);

  useLayoutEffect(() => {
    const rect = popupRef.current?.getBoundingClientRect();
    // If the popup would be cut off by the top of the screen, flip it below the anchor
    setIsBelow(!!rect && rect.top < 0);
  }, [data]);

  return (
    <div
      ref={popupRef}
      className={`${styles.scoringPopup} ${isBelow ? styles.scoringPopupBottom : ''}`}
      style={{ top: isBelow ? data.bottom : data.top, left: data.left }}
    >
      <div className={styles.scoringPopupImageWrapper}>
        <figure className={styles.scoringPopupImage}>
          <img
            src={
              photosType === 'day' || photosType === 'ndvi'
                ? (resizeImageCard(data.imageDay) ?? '')
                : (resizeImageCard(data.imageNight) ?? '')
            }
            alt=""
            loading="lazy"
          />
        </figure>
      </div>
      <div className={styles.scoringPopupBody}>
        <CroplerIcon name="aiColored" />
        {data.text}
      </div>
    </div>
  );
};

export default ScoringPopup;
